import { createAction } from '@reduxjs/toolkit';

export const FETCH_CALL_HISTORY_ACTION_TYPE = 'saga/fetchCallHistory';
export const fetchCallHistoryAction = createAction(FETCH_CALL_HISTORY_ACTION_TYPE);

// import { createAction } from '@reduxjs/toolkit';

// export const ADD_CARD_ACTION_TYPE = 'saga/addCard';
// export const addCardAction = createAction(ADD_CARD_ACTION_TYPE);
